import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Select, Button } from "antd";
import "./evaluationsFilterSidebarForm.scss";
import useQCEStore from "../../store/qce.store";

function EvaluationsFilterSidebarFrom({qhjid,ev_id,evalDesc,localQDesc ,localQHanlder,
                                       localFilteredList,localFilteredQHanlder,localfilterViewHandler}) {
    const navigate = useNavigate();
    const [selectedSkill, setSkill] = useState(['All']); 
    const [selectedAssessmentType, setAssessmentType] = useState(['All']); 
    const [selectedWeightage, setWeightage] = useState("All"); 
    const [selectedSource, setSelectedSource] = useState("All"); 

    const {updateFilterFlag,resetFiterFlagQuestions} = useQCEStore();

    const getSkillList = evalDesc.skillarray?.map((skillItem,idx) => {                                                    
          return { value: skillItem.skill.toUpperCase(), label: skillItem.skill.toUpperCase()}      
      })  
    
    useEffect(() => {
       
    }, []);

    useEffect(() => {
       if(updateFilterFlag){
         //console.log("Filtering again")
         DoFilter()
         resetFiterFlagQuestions()
       }         
    }, [updateFilterFlag]);

    const aaList = [
      {"value": "All", "label": "All"}
    ] 
    const CombinedSills = [...getSkillList, ...aaList]
    
  const handleSelect = (value, type) =>{
    console.log("selecteD",value,type)
    if(type == 'SKILL'){
      setSkill([...value])
    }else if(type =='ASSESSMENTTYPE'){
     setAssessmentType(value)
    }else if (type == 'WEIGHTAGE'){
      setWeightage(value)
    }else {
      setSelectedSource(value)
    }
  }
  const handleFilterReset= () => {
     localfilterViewHandler("normal") 
  }

  const DoFilter = () => { 

    var filteredQuestions,filteredQuestionsTemp,filteredQuestionsTemp2

     //copy it
     filteredQuestions = [...localQDesc]
     filteredQuestionsTemp = filteredQuestions

     //console.log("Values",values)
     //console.log("All Questions- Filtered Input",filteredQuestions,selectedSkill)

     if(selectedAssessmentType?.includes("All") == false){
            filteredQuestionsTemp =[]
            for(let idx = 0; idx < selectedAssessmentType?.length; idx++){
              filteredQuestionsTemp2 = filteredQuestions.filter((item)=>selectedAssessmentType[idx] == item.assessmenttype)
              //console.log("Filtered Questions 111" ,idx,filteredQuestionsTemp2)
              filteredQuestionsTemp = [...filteredQuestionsTemp,...filteredQuestionsTemp2]
        }
     }
     if(selectedSkill?.includes("All") == false){
            filteredQuestionsTemp =[]
            for(let idx = 0; idx < selectedSkill?.length; idx++){
              filteredQuestionsTemp2 = filteredQuestions.filter((item)=>selectedSkill[idx].toLowerCase() == item.skill.toLowerCase())
              filteredQuestionsTemp = [...filteredQuestionsTemp,...filteredQuestionsTemp2]
            }
     }
     if(selectedWeightage != "All"){
        filteredQuestionsTemp = []
        for(let idx = 0; idx < filteredQuestions?.length; idx++){
          for(let index = 0; index <  evalDesc.skillarray?.length; index++){
             if( evalDesc.skillarray[index].skill.toLowerCase() == filteredQuestions[idx].skill.toLowerCase()){
                 var weightage = evalDesc.skillarray[index].weightage?"Mandatory":"Optional"
                if(weightage ==selectedWeightage ){
                   filteredQuestionsTemp.push(filteredQuestions[idx])
                 }
             }
          }
        }
     }
     if(selectedSource != "All"){
        filteredQuestionsTemp = filteredQuestions.filter((item)=>selectedSource == item.source)  
     } 

     console.log("Filtered Questions",filteredQuestionsTemp)     
     localFilteredQHanlder(filteredQuestionsTemp)                   
  };

  const handleFormSubmitFilter = (values) => { 
    DoFilter()
     //localQHanlder(filteredQuestions) 
    localfilterViewHandler("filtered")                  
  };

  return (
    <div className="resume-filter-sidebar-wrapper">
        <Form
          className="jd-creation-form"
          name="rdb-filter-form"
          justify="start"
          layout="vertical"
          autoComplete="off"
          onFinish={handleFormSubmitFilter}
        >

        <Form.Item
          className="jd-creation-field-item"
          label="Skills"
          name="skills"
        >
          <Select
            className="jd-creation-input" 
            mode="multiple"
            allowClear                            
            placeholder= {selectedSkill}
            onChange={(val)=>handleSelect(val,'SKILL')}
            options={CombinedSills}
          />                         
        </Form.Item>
        <Form.Item
          className="jd-creation-field-item"
          label="Assessment Type"
          name="assessmenttype"
        >          
          <Select
            className="jd-creation-input" 
            mode="multiple"
            allowClear                           
            placeholder={selectedAssessmentType}
            onChange={(val)=>handleSelect(val,'ASSESSMENTTYPE')}
            options={[
                      { value: 'Programming', label: 'Programming' },
                      { value: 'Domain', label: 'Domain' },
                      { value: 'Framework', label: 'Framework' },
                      { value: 'Role', label: 'Role' },
                      { value: 'Exp', label: 'Exp' }, 
                      { value: 'All', label: 'All' },  
                      ]}
          />                         
        </Form.Item>
         <Form.Item
          className="jd-creation-field-item"
          label="Weightage"
          name="weightage"
        >
          <Select
            className="jd-creation-input"                          
            placeholder={selectedWeightage}
            onChange={(val)=>handleSelect(val,'WEIGHTAGE')}
            options={[
                      { value: 'Mandatory', label: 'Mandatory' },              
                      { value: 'Optional', label: 'Optional' },
                      { value: 'All', label: 'All' },
                      ]}
          />                         
        </Form.Item>
        <Form.Item
          className="jd-creation-field-item"
          label="Source"
          name="source"
        >
          <Select
            className="jd-creation-input"                          
            placeholder={selectedSource}
            onChange={(val)=>handleSelect(val,'SOURCE')}
            options={[
                      { value: 'AI Generated', label: 'AI Generated' },              
                      { value: 'Custom', label: 'Custom' },
                      { value: 'All', label: 'All' },
                      ]}
          />                         
        </Form.Item>        
          <Button
              style={{ width: "60%", height: "40px", fontWeight: "600" }}
              type="primary"
              htmlType="submit"
          >
              Update Filter
          </Button>
        </Form>
        <div style={{ marginTop: "30px" }}>
          <Button
                style={{ width: "60%", height: "40px", fontWeight: "600" }}
                onClick={handleFilterReset}
          >
                Reset Filter
          </Button>
        </div>

    </div>
  );
}

export default EvaluationsFilterSidebarFrom;
